export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20editorial%20illustration%20with%20warm%20crimson%20red%20and%20dark%20charcoal%20tones%2C%20abstract%20geometric%20shapes%20floating%2C%20trending%20arrow%20motifs%2C%20speech%20bubble%20silhouettes%2C%20megaphone%20outline%2C%20news%20headline%20vibe%2C%20pop%20art%20aesthetic%2C%20high%20contrast%20dramatic%20lighting%2C%20clean%20modern%20composition%2C%20bold%20graphic%20style%2C%20entertainment%20media%20theme%2C%20no%20text&width=1920&height=1080&seq=mrds-hero-bg&orientation=landscape"
          alt="每日大赛mrds品牌主视觉"
          className="w-full h-full object-cover object-center"
          onError={(e) => {
            const target = e.currentTarget;
            target.style.display = 'none';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-32">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-xs font-medium tracking-wider mb-6 whitespace-nowrap">
              实时爆料排行 · 热点话题追踪
            </span>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
              每日大赛mrds
              <span className="block text-primary-400 mt-2">
                全网黑料评选与吃瓜排位赛
              </span>
            </h1>

            <p className="text-lg md:text-xl text-primary-300 font-heading font-medium mb-6">
              每日吃瓜大赛，一触即发
            </p>

            <p className="text-sm md:text-base text-background-200/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              每日大赛mrds打造每日吃瓜排位赛，汇聚全网最新黑料评选平台与实时爆料排行。
              追踪热点话题和娱乐梗图，看全民投票决定今日瓜王归属。
              每日更新，永不缺席，你的每一次参与都在改写吃瓜排行榜。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">24h</div>
                <div className="text-xs text-background-300 mt-1 whitespace-nowrap">全天候实时更新</div>
              </div>
              <div className="w-px h-10 bg-background-50/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">10万+</div>
                <div className="text-xs text-background-300 mt-1 whitespace-nowrap">活跃吃瓜群众</div>
              </div>
              <div className="w-px h-10 bg-background-50/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">1000+</div>
                <div className="text-xs text-background-300 mt-1 whitespace-nowrap">每日新鲜爆料</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer no-underline"
              >
                查看今日吃瓜排行
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-50/30 hover:border-background-50/60 text-background-50 rounded-full font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer no-underline"
              >
                我要爆料投稿
                <i className="ri-mail-send-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden bg-background-950/40 backdrop-blur-sm border border-background-50/10">
              <img
                src="https://readdy.ai/api/search-image?query=Bold%20editorial%20pop%20art%20illustration%2C%20dynamic%20composition%20of%20trending%20charts%20and%20ranking%20badges%2C%20megaphone%20and%20star%20rating%20elements%2C%20warm%20crimson%20red%20and%20gold%20amber%20accents%20on%20dark%20background%2C%20entertainment%20award%20show%20vibe%2C%20trophy%20silhouette%2C%20speech%20bubbles%20floating%2C%20voting%20hands%20abstract%2C%20clean%20modern%20design%2C%20editorial%20magazine%20style%2C%20no%20text&width=800&height=700&seq=mrds-hero-visual&orientation=landscape"
                alt="每日吃瓜大赛排位赛主视觉"
                className="w-full h-auto object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}